<template>
  <div style="background: #1f1c1f;" class="jk-page">
    <div class="header">
      <div class="header_content">
        <div class="img">
          <img src="/img/shouye.png" alt="" style="height:40px"/>{{$t("q94")}}
        </div>
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        
        <!-- <div style="display: flex; " v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#f3c7a2" size="24" />
        </div> -->
      </div>
    </div>
    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v,key) in banners" :key="key">
           
            <van-image class="banner_img"  :src="`${v.url}`" width="100%" height="160px">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
    </div>
    <div style="padding: 10px; ">
      <van-notice-bar
        class="notice-swiper"
        color="#f3c7a2"
        background="#313131"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="/img/neww/notice.png"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <div class="nav_box">
      <!--<div class="x_p" @click="toLogin('/Lottery')">
        <img src="/img/neww/ico_vote.png" alt="" />
        <div class="text_c">{{$t("q37")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/ServiceOnline')">
        <img src="/img/neww/ico_new.png" alt="" />
        <div class="text_c">{{$t("q38")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/Video')">
        <img src="/img/neww/ico_video.png" alt="" />
        <div class="text_c">{{$t("q39")}}</div>
      </div>
      <div class="x_p"  @click="toLogin('/Choose')">
        <img src="/img/neww/ico_vip.png" alt="" />
        <div class="text_c">{{$t("q40")}}</div>
      </div>-->
      <div class="tu_item">
        <div class="top_con" style="position:relative;z-index:99;display:flex;">
          <div class="left_con" style="width:32%;position:relative;z-index:99;">
            <div class="web_n" style="margin:15px 0px;font-size:4.267vw;text-aligh:center;margin-top:3vw;color:#edbd71;
            ">{{$t("q63")}}</div>
            <span style="color:#ddb285;padding-tip:10px;text-align:center;">{{$t("q64")}}</span>
          </div>
          <div class="right_con" style="flex:1;padding-left:1.333vw;border-left: 1px solid #f6d5a1">
            <p style="color: #dadada;font-size: 3vw;line-height: 6.4vw;">
              <font dir="auto" style="vertical-align: inherit;">
                <font dir="auto" style="vertical-align: inherit;">{{$t("q65")}}</font>
              </font>
              <b>
                <font dir="auto" style="vertical-align: inherit;">
                  <font dir="auto" style="vertical-align: inherit;">1%</font>
                </font>
              </b>
              <font dir="auto" style="vertical-align: inherit;">
                <font dir="auto" style="vertical-align: inherit;">{{$t("q66")}}{{$t("q67")}}{{$t("q68")}}{{$t("q69")}}
                </font>
              </font>
            </p>
          </div>
        </div>
        <div class="bottom_con" style="color: #ddb285;font-size: 3vw;padding-top: 1.333vw;text-align: center;">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">
              {{$t("q70")}}{{$t("q71")}}{{$t("q72")}}
            </font>
          </font>
        </div>
      </div>
    </div>
    <div class="wuzii" @click="toLogin('/Choose')" style="display:none;">
      <div class="put_tit">{{$t("q41")}}：</div>
      <div class="xx_bc">
        <div class="top_link">{{$t("q42")}}</div>
        <div class="top_link">{{$t("q43")}}</div>
        <div class="top_link">{{$t("q44")}}</div>
        <div class="top_link">{{$t("q45")}}</div>
        <div class="top_link">{{$t("q46")}}</div>
        <div class="top_link">{{$t("q47")}}</div>
        <div class="top_link">{{$t("q48")}}</div>
        <div class="top_link">{{$t("q49")}}</div>
        <div class="top_link">{{$t("q50")}}</div>
        <div class="top_link">{{$t("q51")}}</div>
      </div>
    </div>
    <div class="nav_tab navs" style="margin: 3.467vw 2.667vw 2.133vw;display:none;width: calc(100% - 5.334vw);">
      <nav style="padding-top: 2vw;display: flex;justify-content: flex-start;flex-wrap: wrap;">
        <a :class="showSourceList&&'active'"  @click="changeShow(true)">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">
              {{$t("q73")}}
            </font>
          </font>
        </a>
        <a  :class="!showSourceList&&'active'"  @click="changeShow(false)">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">
              {{$t("q74")}}
            </font>
          </font>
        </a>
      </nav>
    </div>
    <div class="wuzii_p" v-show="showSourceList">
      <div class="put_tit">{{$t("q52")}}</div>
      <div class="xx_bc_u" @click="toLogin('/Choose')">
        {{$t("q53")}}
      </div>
    </div>
    <div id="scroll-container">
      <div id="scroll-wrap">
        <div class="scroll-content">
          <img data-v-4dd79510="" src="/img/neww/youtu.png" alt="YouTube" class="social_icon social_icon_large">
          <img data-v-4dd79510="" src="/img/neww/fb.png" alt="Facebook" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/ins.png" alt="Instagram" class="social_icon social_icon_no_bg">
          <img data-v-4dd79510="" src="/img/neww/tiki.png" alt="TikTok" class="social_icon social_icon_no_bg">
          <img data-v-4dd79510="" src="/img/neww/huo.png" alt="Huo" class="social_icon social_icon_small">
          <img data-v-4dd79510="" src="/img/neww/1.png" alt="1" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/2.png" alt="2" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/3.png" alt="3" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/4.png" alt="4" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/5.png" alt="5" class="social_icon">
        </div>
        <div class="scroll-content">
          <img data-v-4dd79510="" src="/img/neww/youtu.png" alt="YouTube" class="social_icon social_icon_large">
          <img data-v-4dd79510="" src="/img/neww/fb.png" alt="Facebook" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/ins.png" alt="Instagram" class="social_icon social_icon_no_bg">
          <img data-v-4dd79510="" src="/img/neww/tiki.png" alt="TikTok" class="social_icon social_icon_no_bg">
          <img data-v-4dd79510="" src="/img/neww/huo.png" alt="Huo" class="social_icon social_icon_small">
          <img data-v-4dd79510="" src="/img/neww/1.png" alt="1" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/2.png" alt="2" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/3.png" alt="3" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/4.png" alt="4" class="social_icon">
          <img data-v-4dd79510="" src="/img/neww/5.png" alt="5" class="social_icon">
        </div>
      </div>
    </div>

    <!-- <div>
      <div style="margin: 10px;">
        <span style="font-size: 16px;">  {{$t("index.Highend_area")}}</span>
        <span class="sub">{{$t("index.extreme")}}</span>
      </div>
      <div
        style="
          display: flex;
          width: 100%;
          overflow-y: auto;
          flex-wrap: nowrap;
          padding: 10px;
        "
      >
        <div
          class="gdgride"
          style="margin-right: 5px;"
          v-for="(group, index) in groupedData"
          :key="index"
        >
          <div v-for="item in group" :key="item.id">
            <div
              @click="toDetail(item.id)"
              class="van-image"
              style="
                width: 100px;
                height: 100px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span><i>{{$t("index.airborne")}}</i></span>
            <div
              style="
                position: absolute;
                bottom: 10px;
                text-align: center;
                color: rgb(255, 255, 255);
                width: 100%;
                font-size: 12px;
              "
            >
              {{ item.xuanfei_name }}
            </div>
          </div>
        </div>

        <div
        @click="toLogin('/Choose')"
          style="
            width: 23px;
            padding: 20px 5px 10px;
            height: 145px;
            margin-top: 30px;
            background: rgb(249, 249, 249);
            color: rgb(153, 153, 153);
            font-size: 12px;
          "
        >
          {{$t("concubine.ckgdsj")}}
        </div>
      </div>
    </div> -->
    <div class="tu_list" v-show="showSourceList">
      <div class="tu_item" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
        <div class="renzh">{{$t("q54")}}</div>
        <div class="info_box">
          <div class="c_id">{{ item.xuanfei_name }}</div>
          <!-- <div class="c_c">{{ item.xuanfei_name }}</div> -->
          <div class="c_c">{{$t("index.height")}}: {{item.hight}}cm</div>
          <div class="c_c">{{$t("index.bust")}}：{{ item.bust }}</div>
          <div class="c_c">{{$t("index.address")}}： {{item.flag}}</div>
          <div class="c_c">{{$t("index.National")}}: {{$t("index.yes")}}</div>
          <div class="c_b_k">
            <img src="/img/neww/icon_views.png" class="sm_in">
            <span>{{item.chakan}}</span>
            <img src="/img/neww/icon_love.png" class="sm_in cc">
            <span>{{item.dianzan}}</span>
          </div>
        </div>
        <div class="avatar_container">
          <img :src="item.img_url" class="sm_in_c van-image__img"
          style="object-fit: cover;">
          <div class="audio_logo">
            <img src="/img/neww/yp.gif" alt="ypLogo">
          </div>
        </div>
      </div>
    </div>
    <div class="tiaokuan" v-show="!showSourceList">
      <div>
        <p class="tiaokuan_title">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">平台資源{{$t("q75")}}</font>
          </font>
        </p> 
        <span class="tiaokuan_con">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">{{$t("q76")}}
            </font>
          </font>
        </span>
      </div>
      <div>
        <p class="tiaokuan_title">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">{{$t("q77")}}</font>
          </font>
        </p> 
        <span class="tiaokuan_con">
          <font dir="auto" style="vertical-align: inherit;">
            <font dir="auto" style="vertical-align: inherit;">{{$t("78")}}</font>
          </font>
        </span>
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
          <div  class="imgBox">
            <div
              
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span ><i>{{$t("concubine.high_end")}}</i></span>
          </div>
          <div  style="width: calc(100% - 140px);">
            <div  class="top">
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span >{{$t("index.authentication")}}</span>
              </div>
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span >{{$t("index.video_authentication")}}</span>
              </div>
              <div
                
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
               {{ item.xuanfei_name }}
              </div>
            </div>
            <div  class="tags">
              <van-tag
        v-for="(tag, index) in item.flagArray"
        :key="index"
        :type="tagTypes[index]"
      >
        {{ tag }}
      </van-tag>
              
            </div>
            <div  style="display: flex; align-items: center;">
              <span
                
                style="font-size: 14px; color: rgb(102, 102, 102);"
                >{{$t("index.toll")}}：</span
              >
              <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
            </div>
            <div
              
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
            {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>
            <div  class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      style="
        background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139));
        width: 96%;
        margin: 0px auto 30px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          color: rgb(255, 232, 105);
          text-align: center;
          padding: 10px 0px;
        "
      >
        {{$t("79")}} 1590 {{$t("80")}}
      </div>
      <div class="OnlineMatching">
   
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ {{$t("81")}}</li>
              <li>しらつちのりこ {{$t("81")}}</li>
              <li>はくやすのり {{$t("81")}}</li>
              <li>はくやすのり {{$t("81")}}</li>
              <li>ふちれいこ {{$t("81")}}</li>
              <li>ちのなな {{$t("81")}}</li>
              <li>ちのなな {{$t("81")}}</li>
              <li>たけじかずのぶ {{$t("81")}}</li>
              <li>たけじかずのぶ {{$t("81")}}</li>
              <li>ふちれいこ {{$t("81")}}</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ {{$t("81")}}</li>
              <li>しらつちのりこ {{$t("81")}}</li>
              <li>はくやすのり {{$t("81")}}</li>
              <li>はくやすのり {{$t("81")}}</li>
              <li>ふちれいこ {{$t("81")}}</li>
              <li>ちのなな {{$t("81")}}</li>
              <li>ちのなな {{$t("81")}}</li>
              <li>たけじかずのぶ {{$t("81")}}</li>
              <li>たけじかずのぶ {{$t("81")}}</li>
              <li>ふちれいこ {{$t("81")}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      showSourceList:true,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },
  methods: {
    changeShow(type){
      this.showSourceList=type;
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
      console.log(res,11)
      });
    },
    getBanner(data){
      this.banners = data.banners;
      console.log(this.banners,'this.bannersthis.bannersthis.banners');
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 4, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
  },

  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
#scroll-container {
  overflow: hidden;
  white-space: nowrap;
      margin: 20px;
    padding: 15px 0;
    background: linear-gradient(120deg,#212121,#313131);
    border: 1px solid #766350;
    border-radius: 16px;
}
#scroll-wrap{
  display: flex;
    align-items: center;
    gap: 20px;
    animation: scrollIcons 5s linear infinite;
    width: -moz-fit-content;
    width: fit-content;
}
.scroll-content {
      display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
    img{
      width:40px;
      height:40px;
    }
}

@keyframes scrollIcons {
  0% {
        transform: translateX(0)
    }

    to {
        transform: translateX(-50%)
    }
}

.tiaokuan{
  float: left;
    margin-top: 1.333vw;
    min-height: 1.867vw;
    background-color: #262626 !important;
    border: .01rem solid #7e6a56;
    position: relative;
    overflow: hidden;
    margin-bottom: 1.333vw;
    border-radius: 1.333vw;
    border: 1px solid #7e6a56;
    padding: 1.333vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: 3.467vw 2.667vw 2.133vw;
    width: calc(100% - 5.334vw);
    .tiaokuan_title{
      color: #e1be9c;
      background-image: -webkit-linear-gradient(top, #f8dbae, #edbd71);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 3.733vw;
      font-weight: 600;
      text-align: left;
      padding: 1.333vw 0;
    };
    .tiaokuan_con{
      font-size: 3vw;
      color: #fff;
    }
}
.nav_tab>nav a{
  padding: 1.333vw 2vw;
    border-radius: 6.667vw;
    margin-right: 1.867vw;
    background: linear-gradient(90deg, #5b606c, #2b2b2b);
    color: #fff;
    margin-bottom: 1.333vw;
    font-size: 2.667vw;
}
.nav_tab>nav a.active{
      background: linear-gradient(#fde3ca, #e7b486);
    color: #8a5623;
    font-size: 2.667vw;
}
.tu_list{
  .tu_item{
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    background: linear-gradient(120deg,#212121,#313131);
    border: 1px solid #766350;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .avatar_container{
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 10px;
      .audio_logo{
        text-align: center;
        margin-top: 10px;
        cursor: pointer;
        img{
          height: 11vw;
        }
      }
    }
    .renzh{
      position: absolute;
      right: -72px;
      top: 32px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(90deg, #efcba7, #dcab76);
      color: #000000;
    }
    .sm_in_c{
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box{
      .c_id{
        width: 200px;
        text-align: center;
        background-color: #fff;
        background: linear-gradient(90deg, #efcba7, #dcab76);
        color: #8d5825;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .c_c{
        color: #ddd;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k{
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in{
          width: 30px;
          height: 30px;
          &.cc{
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.nav_box{
  display: none;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    flex:1;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 1rem;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 20px;
    background-color: #e6b98a;
    left: 0;
    top: 0px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    
    padding-top: 10px;
    justify-content: space-between;
    .top_link{
      padding: 20px 20px;
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 55px;
  
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    display: inline-flex;
    align-items: center;
    img {
      width: auto;
      height: 100%;
      margin-right: 10px;
    }
  }
}
.notice-swiper {
  height: 45px;
  font-size: 1rem;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
</style>
